/**
 * HAWK DESIGN - Uygulama girişi
 *
 * Yükleme sırası (index.html):
 *   HawkLoader -> HawkUtils -> Hawk3DCore -> HawkMaterialManager
 *   -> HawkProductLogic -> HawkUIController -> HawkCheckout -> HawkARManager -> main.js
 *
 * Bu dosya sadece global veri yapılarını kurar ve sistemi başlatır.
 */

document.addEventListener("DOMContentLoaded", async () => {
    if (window.hawkLoader) window.hawkLoader.show("Sistem Başlatılıyor...");

    // 1. GLOBAL VERİ YAPILARI
    window.orderData = {
        "ProductID": 1,
        "PaymentAmount": 0,
        "Customer": { "FirstName": "", "LastName": "", "Email": "", "Phone": "", "Message": "", "IPNumber": "127.0.0.1" },
        "Delivery": { "FirstName": "", "LastName": "", "Email": "", "Phone": "", "Address": "", "District": 0, "Province": 0, "Country": "TR" },
        "Invoice": { "Type": 0, "Company": "", "TaxNumber": "", "TaxOffice": "", "FirstName": "", "LastName": "", "Email": "", "Phone": "", "Address": "" },
        "Features": {
            "PatternID": 1,
            "Patterns": { "Front": "", "Back": "", "Waist": "", "Side": "" },
            "Nickname": { "Text": null, "Color": "" }
        }
    };

    // Legacy Support (Eski kodlar için)
    window.siparis_data = { koltuk: ["futureCoal"], nickname: ["yok"], on_logo: ["yok"], arka_logo: ["yok"], bel_logo: ["yok"], yastik_logo: ["yok"], nicknamecolor: ["#ffffff"] };
    window.onlogoyuklendi = false; window.arkalogoyuklendi = false; window.bellogoyuklendi = false; window.yastiklogoyuklendi = false; window.nicknameyuklendi = false;
    window.resultonlogo = []; window.resultarkalogo = []; window.resultbellogo = []; window.resultyastiklogo = [];

    // --- KRİTİK: GLOBAL GÜNCELLEME FONKSİYONU ---
    window.updateOrderJson = function (value, path) {
        if (!window.orderData) return;
        let schema = window.orderData;
        const pList = path.split('.');
        const len = pList.length;
        for (let i = 0; i < len - 1; i++) {
            const elem = pList[i];
            if (!schema[elem]) schema[elem] = {}
            schema = schema[elem];
        }
        schema[pList[len - 1]] = value;
    };

    // 2. UI ELEMENTLERİNİ HAZIRLA
    if (window.hawkUI) {
        if (typeof window.hawkUI.initOrderTracking === 'function') window.hawkUI.initOrderTracking();
        if (typeof window.hawkUI.initCustomizationArea === 'function') window.hawkUI.initCustomizationArea();
    }

    // 3. URL KONTROLÜ
    const urlParams = new URLSearchParams(window.location.search);
    const isApproved = urlParams.get('approved') !== '0';

    // 4. SİSTEMİ BAŞLAT
    if (window.hawkProduct) {
        if (window.hawkLoader) window.hawkLoader.updateMessage("Ürün katalogları getiriliyor...");

        await window.hawkProduct.init(isApproved);

        // 5. PAYLAŞIM LİNKİ (?future/coal/desen) İLE GELEN TASARIMI UYGULA
        // init() içinde "isInitialized" kilidi var; bu ikinci çağrı katalogu
        // yeniden çekmez, sadece hazır olan Promise'i döndürür.
        window.hawkProduct.init(true).then(() => {
            console.log("✅ Ürün verileri çekildi. URL kontrolü için model bekleniyor...");

            const modelViewer = document.getElementById("hawkgamingchair");
            if (!modelViewer) {
                console.warn("❌ Model viewer bulunamadı!");
                return;
            }

            modelViewer.addEventListener("load", () => {
                console.log("✅ 3D Model yüklendi. URL parametreleri uygulanıyor...");
                setTimeout(() => {
                    if (window.hawk_data2 && window.hawkUtils) {
                        window.hawkUtils.applyFromURL(window.hawk_data2);
                    }
                }, 500);
            }, { once: true });
        }).catch(error => {
            console.error("Başlangıç hatası:", error);
        });

        if (window.hawkLoader) window.hawkLoader.updateMessage("Fiyat listeleri güncelleniyor...");
    }
});
